export default __webpack_public_path__ + "static/media/1914.e157479a.png";